/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { createComponentRef, detectChanges, getHostElement, markDirty, renderComponent } from './component';
import { NgOnChangesFeature, PublicFeature, defineComponent, defineDirective } from './definition';
export { inject, injectElementRef, injectTemplateRef, injectViewContainerRef, NO_CHANGE as NC, bind as b, bind1 as b1, bind2 as b2, bind3 as b3, bind4 as b4, bind5 as b5, bind6 as b6, bind7 as b7, bind8 as b8, bindV as bV, componentRefresh as r, containerStart as C, containerEnd as c, containerRefreshStart as cR, containerRefreshEnd as cr, directive as D, elementAttribute as a, elementClass as k, elementEnd as e, elementProperty as p, elementStart as E, elementStyle as s, lifecycle as l, listener as L, memory as m, projection as P, projectionDef as pD, query as Q, queryRefresh as qR, text as T, textBinding as t, viewStart as V, viewEnd as v, } from './instructions';
export { QueryList } from './query';
export { NgOnChangesFeature, PublicFeature, defineComponent, defineDirective, };
export { createComponentRef, detectChanges, getHostElement, markDirty, renderComponent };
//# sourceMappingURL=index.js.map